<template>
  <div>
    <v-alert v-model="alert" type="info" dismissible>
      Report generation request is submitted. Please check the status of the process at the <a @click="goToMessageCenter">message center</a>.
    </v-alert> 
    <v-btn color="info" :loading="isSubmittingAsyncGeneratingRequest" @click="generateReport()" :disabled="disabled">
      <v-icon class="mr-2">save_alt</v-icon>
      <!-- <div class="text-capitalize"> {{ $t("Button.DownloadReport") }}</div> -->
       <div class="text-capitalize"> asynchronous report download</div>
    </v-btn>
  </div>
</template>

<script>

  import {
    createNamespacedHelpers,
  } from 'vuex'
    
  import {
    reportTypes,
    reportGroupings,
    makeRequestData,
  } from '@/helpers/multiStationQuery'

  const multiStation = createNamespacedHelpers('multistation')

  export default {
    props: {
      selection: Object,
      reportOptions: Object,
      disabled: Boolean,
    },
    data: () => ({
      isSubmittingAsyncGeneratingRequest: false,
      alert: false,
    }),
    computed: {
      
    },
    watch: {
      'report.reportFormat'(val) {
        if (val == reportTypes.standard && this.reportOptions.organizeWorksheetBy == reportGroupings.station) {
          this.reportOptions.organizeWorksheetBy = reportGroupings.stationMedia
        }
      },
      isSubmittingAsyncGeneratingRequest(val) {
        this.$emit('loading', val)
      },
    },
    methods: {
      ...multiStation.mapActions(['generateDDQReportAsync']),
      async generateReport() {
        this.isSubmittingAsyncGeneratingRequest = true

        let requestData
        try {
          requestData = makeRequestData(this.selection, this.reportOptions, null)
        } catch (error) {
          this.$store.dispatch('app/setSnackbar', {
            text: error,
            color: 'error',
            icon: 'error',
          })

          this.isSubmittingAsyncGeneratingRequest = false
          return
        }

        await this.generateDDQReportAsync(requestData)
        console.log(requestData)
        this.alert = true
        this.isSubmittingAsyncGeneratingRequest = false
        
      },
      goToMessageCenter() {
        this.$router.push({
          name: 'MessageCenter',          
        })
      },
    },
  }
</script>